import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";
const tableHead = [
  "Sr.",
  "Name / Phone No",
  "Department / Date",
  "Joinig Date",
  "Salary Expectation",
  "Remarks",
  "Actions",
];

const getTableHead = (role) => {
  const base = [
    "Sr.",
    "Name / Phone No",
    "Department / Date",
    "Joinig Date",
    "Salary Expectation",
  ];

  if (role !== "client") {
    base.push("Remarks");
  }

  base.push("Actions");

  return base;
};

const Applicationtable = ({ data = [], currentPage, itemsPerPage, userRole }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-applications/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
      <thead>
  <tr>
    {getTableHead(userRole).map((item, index) => (
      <th key={index}>{item}</th>
    ))}
  </tr>
</thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>
                  <span className="border-bottom pb-1">
                    {item.Fname || item.Lname
                      ? `${item.Fname || ""} ${item.Lname || ""}`.trim()
                      : "N/A"}
                  </span>
                  <div className="pt-1">
                    {item?.phoneNo && (
                      <span>
                        <b>{item?.phoneNo}</b>
                      </span>
                    )}
                  </div>
                </td>
                {/* <td>{item?.email || "N/A"}</td> */}
                <td>
                  <span className="border-bottom pb-1">
                    {item?.departments || "N/A"}
                  </span>
                  <div className="pt-1">
                    {item?.createdAt && (
                      <span>{extractDate(item?.createdAt) || "N/A"}</span>
                    )}
                  </div>
                </td>
                <td>{item?.joiningDate || "N/A"}</td>
                <td>{item?.salaryExpectation || "N/A"}</td>
                {userRole !== "client" && (
  <td className="text status-cell">
    {item?.isShortListed ? (
      <span className="badge bg-lime-lt">Shortlisted</span>
    ) : item?.isViewed ? (
      <span className="badge bg-yellow-lt">Viewed</span>
    ) : (
      <span className="badge bg-red-lt">Pending</span>
    )}

    {(item?.isViewed || item?.isShortListed) && (
      <div className="status-tooltip">
        {item?.actionTracking?.some(el => el.action === "VIEWED") && (
          <>
            <strong>Viewed by:</strong>
            {item.actionTracking
              .filter(el => el.action === "VIEWED")
              .map((el, index) => (
                <span key={`viewed-${index}`} style={{ display: "block" }}>
                  {el.by}
                </span>
              ))}
          </>
        )}

        {item?.actionTracking?.some(el => el.action === "SHORTLISTED") && (
          <>
            <strong style={{ marginTop: "8px", display: "block" }}>
              Shortlisted by:
            </strong>
            {item.actionTracking
              .filter(el => el.action === "SHORTLISTED")
              .map((el, index) => (
                <span key={`shortlisted-${index}`} style={{ display: "block" }}>
                  {el.by}
                </span>
              ))}
          </>
        )}
      </div>
    )}

    <style>
      {`
        .status-cell {
          position: relative;
          cursor: pointer;
        }
        .status-tooltip {
          position: absolute;
          top: 0%;
          right: 10%;
          transform: translateX(-50%) translateY(8px);
          width: 240px;
          background: #1e293b;
          color: #ffffff;
          padding: 12px 14px;
          border-radius: 10px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: all 0.25s ease;
          z-index: 1000;
        }

        .status-cell:hover .status-tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }

        .status-tooltip strong {
          display: block;
          margin-bottom: 4px;
          color: #38bdf8;
          font-size: 13px;
        }

        .status-tooltip::before {
          content: "";
          position: absolute;
          top: -6px;
          left: 50%;
          transform: translateX(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: transparent transparent #1e293b transparent;
        }
      `}
    </style>
  </td>
)}


                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Applicationtable;
